'use client';

import { Box, freddyTheme, VideoContainer } from '@coolblue-development/freddy';
import { Image } from '@coolblue-development/next-image/client';

import { ControlButtons, COVER_WIDTH, useVideoCapability, VIDEO_CARD_MOBILE_HEIGHT } from './';

interface VideoCardProps {
  videoId: string | undefined;
}

export const VideoCard = ({ videoId }: VideoCardProps) => {
  const { shouldAttemptVideo, videoReady, videoWrapperRef } = useVideoCapability(videoId);

  return (
    <Box
      sx={{
        position: 'relative',
        height: VIDEO_CARD_MOBILE_HEIGHT,
        overflow: 'hidden',
        width: '100%',
        [freddyTheme.breakpoint.minWidth('lg')]: {
          position: 'absolute',
          top: 0,
          left: 0,
          height: '-webkit-fill-available'
        }
      }}
    >
      {/* Image always rendered as base layer */}
      <Image
        hideUntil='lg'
        imageId='1008173313'
        fileCollection='content'
        fullWidth
        fullHeight
        width={1920}
        height={800}
        objectFit='cover'
        alt='Our culture background image'
        loading='eager'
        sx={{ position: 'absolute', inset: 0 }}
      />

      <Image
        hideFrom='lg'
        imageId='1008173313'
        fileCollection='content'
        fullWidth
        fullHeight
        width={850}
        height={150}
        objectFit='cover'
        alt='Our culture background image'
        loading='eager'
        sx={{ position: 'absolute', inset: 0 }}
      />

      {/* Video fades in when iframe loads */}
      {shouldAttemptVideo && videoId && (
        <Box
          ref={videoWrapperRef}
          sx={{
            position: 'absolute',
            inset: 0,
            opacity: videoReady ? 1 : 0,
            transition: 'opacity 0.7s ease'
          }}
        >
          <VideoContainer
            videoId={videoId}
            title='Home Page background video'
            autoPlay
            loop
            mute
            hideControls
            sx={{
              position: 'absolute',
              pointerEvents: 'none',

              // it makes sure that youtube video covers the entire container
              '& iframe': {
                top: '50%',
                left: '50%',
                minWidth: COVER_WIDTH,
                transform: 'translate(-50%, -50%)'
              }
            }}
          />
        </Box>
      )}
      {/* Dimmed overlay */}
      <Box
        sx={{
          position: 'absolute',
          inset: 0,
          pointerEvents: 'none',
          backgroundColor: freddyTheme.color.background.backdropDimmed
        }}
      />
      {videoReady && <ControlButtons />}
    </Box>
  );
};
